import { render, staticRenderFns } from "./PaymentServicesAct.vue?vue&type=template&id=36e585a6"
import script from "./PaymentServicesAct.vue?vue&type=script&lang=ts"
export * from "./PaymentServicesAct.vue?vue&type=script&lang=ts"
import style0 from "./PaymentServicesAct.vue?vue&type=style&index=0&id=36e585a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports